
import { useState } from "react";
import { ImageModal } from "./ImageModal";
import { Maximize2 } from "lucide-react";

interface TopicImageProps {
  imageUrl: string | null;
  topic: string;
}

export const TopicImage = ({ imageUrl, topic }: TopicImageProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!imageUrl) return null;

  return (
    <>
      <div className="relative w-full h-80 group cursor-zoom-in" onClick={() => setIsModalOpen(true)}>
        <img
          src={imageUrl}
          alt={topic}
          className="rounded-lg object-contain w-full h-full border border-border"
          decoding="sync"
        />
        <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
          <Maximize2 className="w-6 h-6 text-stone-700" />
        </div>
      </div>

      <ImageModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        imageUrl={imageUrl}
        topic={topic}
      />
    </>
  );
};
